import { DateTimeFormatter, LocalDate } from "@js-joda/core";
import * as React from "react";
import { ComplianceItem } from "../messages";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { ScreenSkeleton } from "./ScreenSkeleton";

interface ComplianceActivityProps {
  onBackClick: () => void;
  data: ComplianceItem[];
}

interface ComplianceActivityState {}

export class ComplianceActivity extends React.Component<
  ComplianceActivityProps,
  ComplianceActivityState
> {
  constructor(props: ComplianceActivityProps) {
    super(props);
  }

  render() {
    return (
      <ScreenSkeleton
        onBackClick={() => {
          this.props.onBackClick();
        }}
        title={translate(STRINGS.COMPLIANCE)}
        titleBarStyle={ScreenSkeleton.TitleBarStyle.PRIMARY}
        className="ComplianceScreen__skeleton"
      >
        {this.props.data.map((complianceItem) => this.renderComplianceItem(complianceItem))}
      </ScreenSkeleton>
    );
  }

  renderComplianceItem(complianceItem: ComplianceItem) {
    const daysUntilExpiry = LocalDate.now().until(complianceItem.expires).days();

    return (
      <div className="ComplianceScreen__complianceItemContainer">
        <div className="ComplianceScreen__complianceItemInfo">
          <span className="ComplianceScreen__complianceItemName">{complianceItem.name}</span>
          {complianceItem.done ? (
            <span>
              {translate(STRINGS.EXPIRY_DATE) +
                " " +
                complianceItem.expires.format(DateTimeFormatter.ofPattern("dd/MM/yy"))}
            </span>
          ) : (
            ""
          )}
          {complianceItem.done ? (
            <span>{daysUntilExpiry + " " + translate(STRINGS.DAYS_LEFT)}</span>
          ) : (
            ""
          )}
        </div>
        <div className="ComplianceScreen__complianceItemUploadSection">
          <div className="ComplianceScreen__complianceItemUploadStatusContainer">
            <span>{translate(STRINGS.STATUS) + ":  "}</span>
            <span className={"ComplianceScreen__complianceItemUploadStatus" + complianceItem.done}>
              {complianceItem.done ? translate(STRINGS.VALID) : translate(STRINGS.MISSING)}
            </span>
          </div>
          {!complianceItem.done ? (
            <div className="ComplianceScreen__complianceItemUploadButton" />
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}
